import commerceConfig from '@commerce/config'
import { Product } from '@commerce/types'
import { storeBaseUrl } from '@components/common/SEO/SEO'
import { EVENT_DEBUG, eventLog, infoLog } from './general'

declare global {
  interface Window {
    dataLayer: any
  }
}

export const productViewEvent = (product: Product.Product, locale: string) => {
  if (EVENT_DEBUG && !window?.dataLayer) {
    infoLog('Product View: No Data Layer found.')
  }

  const {
    config: { defaultLocale },
  } = commerceConfig

  if (window?.dataLayer) {
    const detail = {
      event: 'productView',
      product_id: product.id.replace('gid://shopify/Product/', ''),
      product_name: product.name,
      url: `${storeBaseUrl}/${
        locale && locale !== defaultLocale ? `${locale}/` : ''
      }product/${product.handle}`,
    }
    window?.dataLayer?.push(detail)
    if (EVENT_DEBUG)
      eventLog(`ProductView 'gtm.ProductView (custom)`, { detail })
  }
}
